import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

const client = axios.create({ baseURL: API, withCredentials: true });

client.interceptors.request.use((config) => {
  const t = localStorage.getItem("sentinel_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// Session-expiry guard: on a 401 from any authenticated call, log out cleanly and
// redirect to /login exactly once — instead of letting every page surface its own
// red error toast (a "storm" of varied messages) when the JWT expires.
let sessionRedirecting = false;
client.interceptors.response.use(
  (res) => res,
  (error) => {
    const status = error.response?.status;
    const url = error.config?.url || "";
    const isAuthBootstrap = /\/auth\/(me|login|pin-login|logout)/.test(url);
    if (status === 401 && !isAuthBootstrap) {
      const onLogin = typeof window !== "undefined" && window.location.pathname.startsWith("/login");
      if (!sessionRedirecting && !onLogin) {
        sessionRedirecting = true;
        localStorage.removeItem("sentinel_token");
        window.location.assign("/login?expired=1");
      }
      // Never settle: prevents each page's own catch(toast.error) from firing during redirect.
      return new Promise(() => {});
    }
    return Promise.reject(error);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default client;
